import { ADDRESS_FOR_CHECKOUT_FRAGMENT } from '@components/pages/CheckoutPage/queries';
import gql from "graphql-tag";

export const ADDRESS_DELETE = gql`
  mutation addressDelete($id: ID!) {
    addressDelete(id: $id) {
      errors {
        field
        message
      }
      address {
        id
      }
    }
  }
`;

export const CUSTOMER_UPDATE_ADDRESS_NICKNAME = gql`
  mutation customerUpdateAddressNickname($id: ID!, $input: AddressInput!){
    addressUpdate(id:$id, input:$input){
      errors{
        field
        message
      }
      address{
        id
        addressNickname
      }
    }
  }
`;

export const SET_DEFAULT_ADDRESS = gql`
  mutation setDefaultAddress($id: ID!) {
    customerSetDefaultAddress(id: $id, type: SHIPPING) {
      errors {
        field
        message
      }
      user {
        defaultShippingAddress {
          id
        }
      }
    }
  }
`;

export const DEFAULT_SHIPPING_ADDRESS = gql`
  ${ADDRESS_FOR_CHECKOUT_FRAGMENT}
  query defaultShippingAddress {
    me {
      defaultShippingAddress {
        ...addressForCheckout
      }
    }
  }
`;